var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetModal from '@/Jetstream/Modal';
JetDialogModal.Content = function JetDialogModalContent(_a) {
    var title = _a.title, children = _a.children;
    return (_jsxs("div", __assign({ className: "px-6 py-4" }, { children: [_jsx("div", __assign({ className: "text-lg" }, { children: title })), _jsx("div", __assign({ className: "mt-4" }, { children: children }))] })));
};
JetDialogModal.Footer = function JetDialogModalFooter(_a) {
    var children = _a.children;
    return _jsx("div", __assign({ className: "px-6 py-4 bg-gray-100 text-right" }, { children: children }));
};
export default function JetDialogModal(_a) {
    var children = _a.children, modalProps = __rest(_a, ["children"]);
    return _jsx(JetModal, __assign({}, modalProps, { children: children }));
}
